export default __webpack_public_path__ + "static/media/Crowley_logo.2cecd99f.png";